/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./originatorDevicesList.vue?vue&type=template&id=6794453a&scoped=true&"
import script from "./originatorDevicesList.vue?vue&type=script&lang=js&"
export * from "./originatorDevicesList.vue?vue&type=script&lang=js&"
import style0 from "./originatorDevicesList.vue?vue&type=style&index=0&id=6794453a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794453a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAutocomplete,VCol,VContainer,VDataTable,VIcon,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
